const faqItems = [
  {
    question: "What services does Laskon Technologies provide?",
    answer: "Laskon Technologies provides custom software and web app development, AI and machine learning, data engineering, cloud and process automation, cybersecurity, quality assurance, digital product strategy, game development, and digital marketing services.",
  },
  {
    question: "How can I choose a software development partner?",
    answer: "Choose a software development partner by checking relevant project experience, technical skills, communication practices, security approach, delivery process, and post-launch support. Start with a clear scope and ask how the team will measure progress and outcomes.",
  },
  {
    question: "Does Laskon build custom web and mobile applications?",
    answer: "Yes. Laskon’s custom software service covers web and mobile application development, API development and integration, full-stack engineering, and scalable microservices architecture.",
  },
  {
    question: "Can Laskon help a business adopt AI?",
    answer: "Yes. Laskon offers AI and machine learning consulting, generative AI solutions, natural language processing, and custom AI/ML model development to help businesses assess and build AI capabilities.",
  },
  {
    question: "How much does custom software development cost?",
    answer: "Project cost depends on scope, integrations, platforms, security needs, and delivery timeline. Share your goals and requirements with Laskon Technologies to discuss an appropriate project plan and estimate.",
  },
];

export default faqItems;
